import { Routes } from '@angular/router';
import { GuidesManagingAnxietyComponent } from './views/guides-managing-anxiety/guides-managing-anxiety.component';
import { GuidesArticleComponent } from './views/guides-article/guides-article.component';
import { GuidesCategoryComponent } from './views/guides-category/guides-category.component';
import { guidesCategoryGuard } from './utils/guides-category.guard';
import { GuidesComponent } from './views/guides/guides.component';

export const GUIDES_ROUTES: Routes = [
	{
		path: 'students-managing-anxiety',
		component: GuidesManagingAnxietyComponent,
	},
	{
		path: ':category/:guideName',
		component: GuidesArticleComponent,
	},
	{
		path: ':category',
		component: GuidesCategoryComponent,
		canActivate: [guidesCategoryGuard],
	},
	{
		path: '',
		component: GuidesComponent,
	},
];
